/**
 * Theme Constants
 *
 * Default values and configuration for theme management.
 */

import type { Theme } from './types';

// ============================================================================
// APP IDENTIFIERS
// ============================================================================

/** Standard app identifiers for the Tonnie platform */
export const APP_IDS = {
  journey: 'journey',
  citizen: 'citizen',
  business: 'business',
} as const;

export type AppId = (typeof APP_IDS)[keyof typeof APP_IDS];

// ============================================================================
// DEFAULT VALUES
// ============================================================================

/**
 * The theme each portal opens with before the person has chosen one: Light
 * for the citizen portals (B2C — Citizen Web, Citizen Mobile), Dark for the
 * business portal (B2B). A choice the person makes is stored per portal and
 * always wins over this default.
 *
 * The page shells (`apps/journey-web/index.html`, `apps/business-web/index.html`)
 * paint the same default before React loads, so there is no flash — change
 * them together.
 */
export const DEFAULT_THEME_BY_APP: Readonly<Record<AppId, Theme>> = {
  journey: 'light',
  citizen: 'light',
  business: 'dark',
};
